import MasterEditorFormatModel from '../Apis/MasterEditorFormat.js'
import Controller from './Controller.js';

export default class MasterEditorFormatController extends Controller {

    constructor() {
        super(new MasterEditorFormatModel());
    }


}